import Tracker from './main';
import { ROLES } from '../../common/auth/roles';

export const trackerRoutes = [
  { name: 'User Events', path: '/user-events', minRole: ROLES.GLOBAL_ADMIN, render: () => <Tracker /> },
];